export const days = [
	{ id: "1", name: "L", value: false },
	{ id: "2", name: "M", value: false },
	{ id: "3", name: "X", value: false },
	{ id: "4", name: "J", value: false },
	{ id: "5", name: "V", value: false },
	{ id: "6", name: "S", value: false },
	{ id: "7", name: "D", value: false },
];
